module.exports = __webpack_public_path__ + "media/images/home/cover-img-9f13f6665961bcd19ea864e65ceddfcc.jpg";